export const FilterIcon = ({ color = "#0E0E0E" }: { color?: string }) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.5 3.5H3.5M6.5 3.5L14.5 3.5M1.5 8H10.5M13.5 8H14.5M1.5 12.5H5.5M8.5 12.5H14.5"
				stroke={color}
				strokeLinecap="round"
			/>
			<circle cx="5" cy="3.5" r="1.5" stroke={color} />
			<circle cx="12" cy="8" r="1.5" stroke={color} />
			<circle cx="7" cy="12.5" r="1.5" stroke={color} />
		</svg>
	);
};
